export function GENERATEID() : string {
    const length = 16
    let result = ''
    let characters  = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++ )
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    return result
}

export async function DELAY(ms: number): Promise<any> {
    return new Promise( resolve => setTimeout(resolve, ms) );
}
